(() => {
  if (window.RiritoStickyStockNotifications) return;

  const ROOT_SELECTOR = '[data-ririto-stock-notification]';
  const ENDPOINT = '/apps/stock-notifications/subscriptions';

  function showEmailFields(root, opener) {
    const fields = root.querySelector('[data-ririto-stock-notification-fields]');
    const email = root.querySelector('[data-ririto-stock-notification-email]');
    if (!fields || !email) return;

    opener.hidden = true;
    fields.hidden = false;
    email.focus();
  }

  async function subscribe(root) {
    if (root.dataset.riritoSubmitting === 'true') return;

    const email = root.querySelector('[data-ririto-stock-notification-email]');
    const button = root.querySelector('[data-ririto-stock-notification-submit]');
    const message = root.querySelector('[data-ririto-stock-notification-message]');
    if (!button || !message || (email && !email.reportValidity())) return;

    root.dataset.riritoSubmitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    message.hidden = true;
    message.textContent = '';

    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          variantId: root.dataset.variantId,
          email: email?.value.trim() || '',
          locale: root.dataset.locale || document.documentElement.lang || 'ro',
        }),
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.ok === false) {
        throw new Error(result.errorMessage || root.dataset.errorMessage);
      }

      message.textContent = result.created === false
        ? root.dataset.existingMessage
        : root.dataset.createdMessage;
      message.hidden = false;
      if (email) email.disabled = true;
    } catch (error) {
      message.textContent = error?.message || root.dataset.errorMessage;
      message.hidden = false;
      button.disabled = false;
      delete root.dataset.riritoSubmitting;
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ririto-stock-notification-open]');
    if (opener) {
      const root = opener.closest(ROOT_SELECTOR);
      if (root) showEmailFields(root, opener);
      return;
    }

    const submitter = event.target.closest('[data-ririto-stock-notification-submit]');
    if (!submitter) return;

    const root = submitter.closest(ROOT_SELECTOR);
    if (root) subscribe(root);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.matches('[data-ririto-stock-notification-email]')) return;

    event.preventDefault();
    const root = event.target.closest(ROOT_SELECTOR);
    if (root) subscribe(root);
  });

  window.RiritoStickyStockNotifications = { subscribe };
})();
